import { useEffect, useState } from "react";
import { ActionButton } from "../components/button"; // This component needs to use t() internally
import { Header } from "../components/headerTypeOne"; // This component uses t() for props
import { SimpleTextBox } from "../components/normalTextBox"; // This component needs to use t() internally for placeholder
import { StickyActionContainer } from "../components/stickyByttonWithConcent"; // This component likely just wraps, no text
// import { Constants } from "../constants/textconstants"; // No longer needed for translatable strings
import { Style } from "../styles/otpverification";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showToast } from "../store/slices/util";
import { post } from "../config/api"; // Assuming VerifyOTPs is a method, not a constant

import { useTranslation } from '../i18n/useTranslation'; // Import the useTranslation hook

export const VerifyOTP = () => {
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [timer, setTimer] = useState(60); // Initial timer value (60 seconds)
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [otp, setOTP] = useState("");
  const [loader, setLoader] = useState(false);

  const data = useLocation();
  const navigate = useNavigate();
  const phoneNumber = data.state.phoneNumber;
  const retailer = data.state.retailer;
  const dispatch = useDispatch();
  const userID = data.state.userID;
  const territoryID = data.state.territoryID;
  const { t } = useTranslation(); // Initialize useTranslation

  useEffect(() => {
    dispatch(
      showToast({ toast: true, toastmessage: t('otp_sent_successfully') }) // Translate toast message
    );
    setTimeout(() => {
      dispatch(showToast({ toast: false, toastmessage: "" }));
    }, 1500);
  }, [dispatch, t]); // Add t to dependency array

  useEffect(() => {
    let countdown;

    // Start countdown if timer > 0
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      // Timer reached 0, show the button
      setIsButtonVisible(true);
      clearInterval(countdown);
    }
    // Cleanup interval on unmount
    return () => clearInterval(countdown);
  }, [timer]);

  const resendOTPHandler = () => {
    const dataa = {
      user_id: userID,
      mobile_number: data.state.phoneNumber,
    };
    setLoader(true); // Set loader when resending

    post("/otp/send", dataa)
      .then((response) => {
        if (response) console.log(response);
        setLoader(false);
        dispatch(
          showToast({ toast: true, toastmessage: t('otp_re_sent_successfully') }) // Translate toast message
        );
        setTimeout(() => {
          dispatch(showToast({ toast: false, toastmessage: "" }));
        }, 1500);
      })
      .catch((error) => {
        setLoader(false);
        window.alert(t('something_went_wrong')); // Translate alert
        console.error("Error fetching data:", error);
      });

    // Logic for resending OTP
    setTimer(60); // Reset timer
    setIsButtonVisible(false); // Hide button again
  };

  const handler = (value) => { // Renamed data to value for clarity
    const regx = /^\d{4}$/;
    setEnableSubmit(regx.test(value));
    setOTP(value);
  };

  return (
    <div>
      <Header
        header={t('retailer_survey')} // Translate header
        subheader={t('otp_verification')} // Translate subheader
      />
      <div style={Style.container}>
        <span style={Style.infoText}>{t('enter_otp_sent_to')} {phoneNumber}</span> {/* Translate infoText with phone number */}
        <SimpleTextBox
          placeholder={t('enter_otp_here')} // Translate placeholder
          onChange={handler}
        />
        <span style={Style.infoTexrtSub}>
          {t('didnt_get_otp')}{" "} {/* Translate 'Didn't get the OTP?' */}
          <mark
            style={Style.resend}
            onClick={() => {
              if (isButtonVisible) {
                resendOTPHandler();
              }
            }}
          >
            {" "}
            {!isButtonVisible ? `00 :${timer < 10 ? `0${timer}` : timer}` : t('resend_OTP')} {/* Translate 'Resend OTP' and format timer */}
          </mark>
        </span>
      </div>
      <StickyActionContainer>
        <ActionButton
          onPress={() => {
            //code for submitting OTP, and on succeffull generation redirect
            const data1 = {
              user_id: userID,
              mobile_number: phoneNumber,
              otp: otp,
            };
            setLoader(true);
            post("/otp/verify", data1)
              .then((response) => {
                if (response.error) { // Assuming response.error indicates a bad OTP
                  window.alert(t('wrong_otp')); // Translate alert
                  setLoader(false); // Turn off loader on error
                  return;
                }
                setLoader(false);
                localStorage.setItem("mobile_number", phoneNumber);
                navigate("/step1", {
                  state: {
                    isNewUser: data.state.isNewUser,
                    retailer: retailer,
                    userID: userID,
                    territoryID: territoryID,
                    createNewUser: data.state.creatingUser,
                    mobile_number: phoneNumber,
                  },
                });
              })
              .catch((error) => {
                setLoader(false); // Turn off loader on general error
                window.alert(t('something_went_wrong')); // Translate alert
                console.error("Error fetching data:", error);
              });
          }}
          text={t('submit')} // Translate button text
          loader={loader}
          isEnabled={enableSubmit}
        />
      </StickyActionContainer>
    </div>
  );
};